import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Collapse } from 'antd';
import AccordionTitle from './AccordionTitle';
import {
  Accordion,
  AccordionSub,
  SalonCover,
  SalonCoverTitle,
  SalonCoverItem,
  SalonCoverLink,
} from './Accordion.style';

// eslint-disable-next-line prefer-destructuring
const Panel = Collapse.Panel;

// const salonListData = require('./salonList.json');

export default class SalonList extends Component {
  static defaultProps = {
    regions: [],
    salonList: null,
  };
  static propTypes = {
    regions: PropTypes.arrayOf(PropTypes.shape()),
    salonList: PropTypes.arrayOf(PropTypes.shape()),
  };
  constructor(props) {
    super(props);
    this.state = {
      currentKey: undefined,
      currentKeySub: undefined,
    };
  }

  getSalons = prefecture => {
    const { salonList } = this.props;
    const data = salonList;

    if (!data) {
      return null;
    }

    for (let i = 0; i < data.length; i += 1) {
      if (data[i].prefecture === prefecture) {
        return data[i].salons;
      }
    }

    return null;
  };
  accordionHandle = key => {
    if (key) {
      this.setState({ currentKey: key });
    } else {
      this.setState({ currentKey: undefined });
    }
  };
  accordionSubHandle = key => {
    if (key) {
      this.setState({ currentKeySub: key });
    } else {
      this.setState({ currentKeySub: undefined });
    }
  };
  render() {
    const { currentKey, currentKeySub } = this.state;
    const { regions } = this.props;
    return (
      <React.Fragment>
        <Accordion accordion onChange={this.accordionHandle}>
          {regions.map((item, index) => (
            <Panel
              id={`regions-${index}`}
              header={
                <AccordionTitle
                  type="parent"
                  isShow={(currentKey && Number(currentKey) === Number(item.id)) || false}
                  title={item.region}
                />
              }
              key={item.id}
              showArrow={false}
            >
              <AccordionSub accordion onChange={this.accordionSubHandle} defaultActiveKey={['1111']}>
                {item.prefectures.map(sub => (
                  <Panel
                    header={
                      <AccordionTitle
                        type="child"
                        isShowChild={(currentKeySub && Number(currentKeySub) === Number(sub.id)) || false}
                        noBorder
                        title={sub.prefecture}
                      />
                    }
                    key={sub.id}
                    showArrow={false}
                  >
                    {(() => {
                      const salons = this.getSalons(sub.prefecture);
                      const items = [];
                      if (salons) {
                        for (let i = 0; i < salons.length; i += 1) {
                          items.push(
                            <SalonCover key={`${item.id}-${i}`}>
                              <SalonCoverTitle>{`${i + 1}. ${salons[i].title}`}</SalonCoverTitle>
                              <SalonCoverItem>
                                <SalonCoverLink
                                  href={`https://maps.google.co.jp/maps?q=${salons[i].address} ${salons[i].title}`}
                                  target="_blank"
                                >{`〒${salons[i].zipcode} ${salons[i].address}`}</SalonCoverLink>
                              </SalonCoverItem>
                              <SalonCoverItem>
                                Tel: <SalonCoverLink href={`tel:${salons[i].tel}`}>{salons[i].tel}</SalonCoverLink>
                              </SalonCoverItem>
                            </SalonCover>
                          );
                        }
                      } else {
                        items.push(<SalonCover key={`${item.id}-nodata`}>no data</SalonCover>);
                      }
                      return items;
                    })()}
                    {/*
                      {sub.salons.map((item, k) => (
                        <SalonCover key={item.id}>
                          <li>{item.title}</li>
                          <li>{item.address}</li>
                          <li>tel:{item.tel}</li>
                        </SalonCover>
                      ))
                      }
                    */}
                  </Panel>
                ))}
              </AccordionSub>
            </Panel>
          ))}
        </Accordion>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SalonListGrooming/Accordion.js